export default __webpack_public_path__ + "static/media/James Walkinshaw.23f80c97.jpg";